<template>
  <v-row
    justify="center"
    align-content="center"
  >
    <v-col
      class="subtitle-1 text-center"
      cols="12"
    >
      {{ loadingText }}
    </v-col>
    <v-col cols="12">
      <v-progress-linear
        color="loading"
        indeterminate
        rounded
        height="6"
      ></v-progress-linear>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'LoadingBarComponent',
  props: {
    loadingText: {
      type: String,
      default: 'Loading'
    }
  }
}
</script>

<style scoped>

</style>
